import type { Category } from '#commerce/gtm/popUp'
import type { PopUpContent } from '#types/components/cms/pop-up'

export default createGlobalState(() => {
  const { $gtm } = useNuxtApp()
  const dismissed = useLocalStorage<Record<string, string>>('dismissedPopups2', {})

  const popUp = ref<PopUpContent | null>(null)

  const popUpElementRef = ref<HTMLElement | null>(null)

  const open = (popUps: PopUpContent[], category: Category, action?: string): void => {
    const now = Date.now()
    dismissed.value = Object.fromEntries(Object.entries(dismissed.value).filter(([_, v]) => Number.parseInt(v) > now))

    popUp.value = popUps?.filter(({ id }) => !dismissed.value[id])[0]
    $gtm.push('popUp.onExpand', category, action)
  }

  const close = (category: Category, action?: string): void => {
    dismissed.value = { ...dismissed.value, [popUp.value!.id]: `${Date.now() + 30 * 24 * 60 * 60 * 1000}` } // 30 days
    popUp.value = null
    $gtm.push('popUp.onClose', category, action)
  }

  const setElementRef = (element) => {
    popUpElementRef.value = element
  }

  return {
    close,
    open,
    popUp,
    popUpBounds: useElementBounding(popUpElementRef),
    setElementRef,
  }
})
